import {ExportModel} from "./ExportModel";
import {Asset} from "../../entities/Asset";
import {AssetService} from "../../services/AssetService";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {NotificationService} from "../../services/NotificationService";
import alasql from "alasql";

export class AssetExportModel extends ExportModel<Asset>{
    static $inject = ['$q','AssetService','CustomFieldNameService','NotificationService'];
    constructor($q:ng.IQService, assetService:AssetService, public cfnService:CustomFieldNameService, public notifyService:NotificationService){
        super($q, cfnService, assetService, notifyService);
    }
    doExport() {
        this.cfnService.getAssetReportSql(this.assignedItems).then((selSql)=> {
            alasql('SELECT ' + selSql + ' INTO CSV("export.csv",{headers:true,separator:","}) FROM ?', [this.assignedItems]);
        });
    }
    getColumnDefs():ng.IPromise<void>{
        return this.cfnService.getAssetColumnDefs().then((data)=>{
            this.nameValuePairs = data;
        });
    }
    getExportType(){
        return "Asset";
    }
}
